<script setup>
import SvgIcon from "@/components/common/svgButton.vue";
import { t } from "@/controllerLK/GlobusLocalization";

defineProps({
  isArchive: {
    type: Boolean,
    default: false
  },
  isArchivePage: {
    type: Boolean,
    default: false
  },
  isEdit: {
    type: Boolean,
    default: false
  },
  isOwner: {
    type: Boolean,
    default: false
  }
});

const emit = defineEmits([
  "toggleAccessList",
  "toggleProjectHistory",
  "update:isArchive",
  "showDeleteProjectModal",
  "toggle-project-history"
]);

</script>

<template>
  <div class="project-control">
    <ButtonAccentSecondary
      :disabled="!isOwner"
      size="large"
      @click="emit('toggleAccessList')"
    >
      <SvgIcon
        class="project-control__icon"
        name="user-plus"
      />
      {{ t('project_modal_control.access') }}
    </ButtonAccentSecondary>

    <ButtonNeutralPrimary
      :disabled="!isEdit || isArchivePage || !isOwner"
      size="large"
      @click="emit('update:isArchive', !isArchive)"
    >
      <SvgIcon
        class="project-control__icon"
        name="archive"
      />
      <template v-if="isArchive">
        {{ t('project_modal_control.in_archive') }}
      </template>
      <template v-else>
        {{ t('project_modal_control.to_archive') }}
      </template>
    </ButtonNeutralPrimary>

    <ButtonNeutralPrimary
      :disabled="!isEdit || !isOwner"
      size="large"
      @click="emit('showDeleteProjectModal')"
    >
      <SvgIcon
        class="project-control__icon"
        name="trash"
      />
      {{ t('project_modal_control.delete') }}
    </ButtonNeutralPrimary>

    <!-- 2309 - скрываем кнопку истории
    <ButtonNeutralPrimary
      :disabled="!isEdit"
      size="large"
      class="project-control__button-access"
      @click="emit('toggle-project-history')"
    >
      <SvgIcon

        class="project-control__icon"
        name="history"
      />
      {{ t('project_modal_control.history') }}
    </ButtonNeutralPrimary> -->
  </div>
</template>

<style scoped lang="scss">

.project-control {
  display: flex;
  gap: 10px;

  &__icon {
    width: 14px;
    height: 14px;
  }

  &__button-access {
    margin-left: auto !important;
  }
}

</style>